import { useEffect, useState } from 'react';
import { createSystemLinkTitleCache, systemLinkTitleCache } from '@/services/systemLinkTitleCache';
import type { loadSystemLinkTitle } from '@/services/loadSystemLinkTitle';
import type { SystemLinkLookup } from '@/utils/resolveSystemLink';

// Явный загрузчик (тесты, stories) получает собственный кэш: те же дедупликация и отмена,
// что у общего, без пакетного запроса к серверу.
const customCaches = new WeakMap<typeof loadSystemLinkTitle, ReturnType<typeof createSystemLinkTitleCache>>();
const cacheFor = (loadTitle?: typeof loadSystemLinkTitle) => {
    if (!loadTitle) return systemLinkTitleCache;
    let cache = customCaches.get(loadTitle);
    if (!cache) customCaches.set(loadTitle, (cache = createSystemLinkTitleCache(loadTitle)));
    return cache;
};

export const useSystemLinkTitle = (lookup?: SystemLinkLookup, loadTitle?: typeof loadSystemLinkTitle) => {
    const key = lookup ? JSON.stringify(lookup) : undefined;
    const [resolved, setResolved] = useState<{ key: string; title?: string }>();
    useEffect(() => {
        if (!key) return;
        return cacheFor(loadTitle).subscribe(JSON.parse(key) as SystemLinkLookup, (title) =>
            setResolved({ key, title }),
        );
    }, [key, loadTitle]);
    return resolved?.key === key ? resolved?.title : undefined;
};
